import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const AuthCtx = createContext(null);
export const useAuth = () => useContext(AuthCtx);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=loading, false=logged out, obj=user
  const [workspaces, setWorkspaces] = useState([]);
  const [workspacesLoaded, setWorkspacesLoaded] = useState(false);
  const [wsId, setWsId] = useState(localStorage.getItem("ws_id") || "");

  const selectWorkspace = useCallback((id) => {
    localStorage.setItem("ws_id", id);
    setWsId(id);
  }, []);

  const loadWorkspaces = useCallback(async () => {
    const r = await api.listWorkspaces();
    setWorkspaces(r.data);
    setWorkspacesLoaded(true);
    const stored = localStorage.getItem("ws_id");
    const valid = r.data.find((w) => w.id === stored);
    if (r.data.length && !valid) selectWorkspace(r.data[0].id);
    else if (valid) setWsId(valid.id);
    return r.data;
  }, [selectWorkspace]);

  const bootstrap = useCallback(async () => {
    try {
      const r = await api.me();
      await loadWorkspaces();
      setUser(r.data.user);
    } catch {
      setUser(false);
    }
  }, [loadWorkspaces]);

  useEffect(() => { bootstrap(); }, [bootstrap]);

  const afterAuth = async (u) => {
    await loadWorkspaces();
    setUser(u);
  };

  const logout = async () => {
    await api.logout();
    localStorage.removeItem("ws_id");
    setUser(false);
    setWorkspaces([]);
    setWsId("");
  };

  const currentWorkspace = workspaces.find((w) => w.id === wsId) || null;

  return (
    <AuthCtx.Provider value={{
      user, setUser, workspaces, workspacesLoaded, wsId, currentWorkspace,
      selectWorkspace, loadWorkspaces, afterAuth, logout,
    }}>
      {children}
    </AuthCtx.Provider>
  );
}
